var m = Object.defineProperty;
var O = Object.getOwnPropertySymbols;
var i = Object.prototype.hasOwnProperty, aa = Object.prototype.propertyIsEnumerable;
var P = (d, o, e) => o in d ? m(d, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : d[o] = e, C = (d, o) => {
  for (var e in o || (o = {}))
    i.call(o, e) && P(d, e, o[e]);
  if (O)
    for (var e of O(o))
      aa.call(o, e) && P(d, e, o[e]);
  return d;
};
var Q = (d, o, e) => new Promise((c, y) => {
  var s = (p) => {
    try {
      k(e.next(p));
    } catch (h) {
      y(h);
    }
  }, b = (p) => {
    try {
      k(e.throw(p));
    } catch (h) {
      y(h);
    }
  }, k = (p) => p.done ? c(p.value) : Promise.resolve(p.value).then(s, b);
  k((e = e.apply(d, o)).next());
});
import "../../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { l as ra } from "../../../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js";
import ea from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input-number/src/InputNumber.js";
import W from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/space/src/Space.js";
import { defineComponent as la, watch as R, computed as X, openBlock as n, createBlock as D, withCtx as w, createElementBlock as v, renderList as V, Fragment as g, createCommentVNode as x, createVNode as _, withDirectives as q, createElementVNode as B, createTextVNode as oa } from "../../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as U, unref as u } from "../../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import ta from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import sa from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import na from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import { toDisplayString as F } from "../../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import { vShow as E } from "../../../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import ua from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import da from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/RadioGroup.js";
import pa from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/Radio.js";
import ca from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/checkbox/src/CheckboxGroup.js";
import fa from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/checkbox/src/Checkbox.js";
const va = {
  key: 0,
  class: "tw:flex tw:items-center"
}, ba = {
  key: 1,
  class: "tw:flex tw:items-center"
}, wa = {
  key: 2,
  class: "tw:flex tw:items-center"
}, _a = {
  key: 3,
  class: "tw:flex tw:items-center"
}, ha = {
  key: 4,
  class: "tw:flex tw:items-center"
}, Aa = /* @__PURE__ */ la({
  __name: "workForm",
  props: {
    formData: {},
    components: {}
  },
  emits: ["update:formData", "submit"],
  setup(d, { expose: o, emit: e }) {
    const c = d, y = e, s = U({});
    R(
      () => c.formData,
      (r) => {
        s.value = C({}, r);
      },
      { immediate: !0 }
    ), R(s, (r) => {
      y("update:formData", r);
    }, { deep: !0 });
    const b = (r, f) => {
      console.log("updateFormData", r, f), s.value[r] = f, y("update:formData", C({}, s.value));
    }, k = ra.debounce((r, f) => {
      b(r, f);
    }, 100), p = X(() => c.components && Array.isArray(c.components) && c.components.length > 0 && c.components.some((r) => r && r.attr && r.attr.name)), h = X(() => (c.components || []).filter((r) => r && r.attr && r.attr.name)), S = U(), Y = U({}), Z = U("small"), $ = () => Q(this, null, function* () {
      yield S.value.validate();
    });
    return R(
      h,
      (r) => {
        const f = {};
        r.forEach((a) => {
          var N;
          (N = a.attr) != null && N.rules && (f[a.attr.name] = a.attr.rules);
        }), Y.value = f;
      },
      { immediate: !0 }
    ), o({
      submit: $
    }), (r, f) => p.value ? (n(), D(u(ta), {
      key: 0,
      ref_key: "formRef",
      ref: S,
      model: s.value,
      size: Z.value,
      "label-placement": "left",
      "label-width": "auto",
      "require-mark-placement": "right-hanging",
      class: "tw:!text-left"
    }, {
      default: w(() => [
        (n(!0), v(g, null, V(h.value, (a, N) => {
          var z, I, A, G;
          return n(), D(u(sa), {
            label: (z = a == null ? void 0 : a.attr) == null ? void 0 : z.label,
            key: N,
            path: (I = a == null ? void 0 : a.attr) == null ? void 0 : I.name,
            required: (A = a == null ? void 0 : a.attr) == null ? void 0 : A.required,
            rules: (G = a == null ? void 0 : a.attr) == null ? void 0 : G.rules
          }, {
            default: w(() => {
              var L, T, j, H, J, K, M;
              return [
                (a == null ? void 0 : a.type) === "select" ? (n(), v("div", va, [
                  _(u(na), {
                    label: (L = a == null ? void 0 : a.attr) == null ? void 0 : L.label,
                    disabled: a == null ? void 0 : a.disabled,
                    value: s.value[(T = a == null ? void 0 : a.attr) == null ? void 0 : T.name],
                    "onUpdate:value": (l) => {
                      var t;
                      return b((t = a == null ? void 0 : a.attr) == null ? void 0 : t.name, l);
                    },
                    options: (j = a == null ? void 0 : a.attr) == null ? void 0 : j.options,
                    class: "tw:!w-[300px]"
                  }, null, 8, ["label", "disabled", "value", "onUpdate:value", "options"]),
                  q(B("span", { class: "after" }, F(a.after), 513), [
                    [E, a.after]
                  ])
                ])) : x("", !0),
                (a == null ? void 0 : a.type) === "input" ? (n(), v("div", ba, [
                  _(u(ua), {
                    value: s.value[(H = a == null ? void 0 : a.attr) == null ? void 0 : H.name],
                    "on-update:value": (l) => {
                      var t;
                      return b((t = a == null ? void 0 : a.attr) == null ? void 0 : t.name, l);
                    },
                    disabled: a == null ? void 0 : a.disabled,
                    class: "tw:!w-[300px]"
                  }, null, 8, ["value", "on-update:value", "disabled"]),
                  q(B("span", { class: "after" }, F(a.after), 513), [
                    [E, a.after]
                  ])
                ])) : x("", !0),
                (a == null ? void 0 : a.type) === "number" ? (n(), v("div", wa, [
                  _(u(ea), {
                    disabled: a == null ? void 0 : a.disabled,
                    value: s.value[(J = a == null ? void 0 : a.attr) == null ? void 0 : J.name],
                    "onUpdate:value": (l) => {
                      var t;
                      return u(k)((t = a == null ? void 0 : a.attr) == null ? void 0 : t.name, l);
                    },
                    class: "tw:!text-center tw:!w-[300px]",
                    "button-placement": "both",
                    min: 1
                  }, null, 8, ["disabled", "value", "onUpdate:value"]),
                  q(B("span", { class: "after" }, F(a.after), 513), [
                    [E, a.after]
                  ])
                ])) : x("", !0),
                (a == null ? void 0 : a.type) === "radio" ? (n(), v("div", _a, [
                  _(u(da), {
                    value: s.value[(K = a == null ? void 0 : a.attr) == null ? void 0 : K.name],
                    "onUpdate:value": (l) => {
                      var t;
                      return b((t = a == null ? void 0 : a.attr) == null ? void 0 : t.name, l);
                    },
                    name: "radiogroup",
                    disabled: a == null ? void 0 : a.disabled,
                    class: "tw:!w-[300px]"
                  }, {
                    default: w(() => [
                      _(u(W), null, {
                        default: w(() => [
                          (n(!0), v(g, null, V(a.attr.options, (l) => (n(), D(u(pa), {
                            key: l.value,
                            value: l.value
                          }, {
                            default: w(() => [
                              oa(F(l.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["value", "onUpdate:value", "disabled"])
                ])) : x("", !0),
                (a == null ? void 0 : a.type) === "check" ? (n(), v("div", ha, [
                  _(u(ca), {
                    value: s.value[(M = a == null ? void 0 : a.attr) == null ? void 0 : M.name],
                    "onUpdate:value": (l) => {
                      var t;
                      return b((t = a == null ? void 0 : a.attr) == null ? void 0 : t.name, l);
                    },
                    class: "tw:!w-[300px]"
                  }, {
                    default: w(() => [
                      _(u(W), { "item-style": "display: flex;" }, {
                        default: w(() => [
                          (n(!0), v(g, null, V(a.attr.options, (l) => (n(), D(u(fa), {
                            key: l.value,
                            value: l.value,
                            label: l.value
                          }, null, 8, ["value", "label"]))), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["value", "onUpdate:value"])
                ])) : x("", !0)
              ];
            }),
            _: 2
          }, 1032, ["label", "path", "required", "rules"]);
        }), 128))
      ]),
      _: 1
    }, 8, ["model", "size"])) : x("", !0);
  }
});
export {
  Aa as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/banjian/workForm.vue2.js
// module id = 1251
// module chunks = 67